import { render, staticRenderFns } from "./task_actions.vue?vue&type=template&id=c87dd934&scoped=true"
import script from "./task_actions.vue?vue&type=script&lang=js"
export * from "./task_actions.vue?vue&type=script&lang=js"
import style0 from "./task_actions.vue?vue&type=style&index=0&id=c87dd934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87dd934",
  null
  
)

export default component.exports